export default {
  heading: "连系至我的教城帐户",
  intro: "多谢登入香港教育城网站。您的帐户还没有与任何教城帐户登记作为登入户口。",
  completed: "登记帐户成功！现在您可以使用您的帐户登入教城网站。",
  submit: "绑定",
  iamsmart: {
    intro: "这是你第一次使用「智方便」登入香港教育城网站，请登入你的教城帐户以完成绑定。",
  },
 form: {
  label: {
    loginId: "电邮 / 登入名称",
    password: "密码",
  }
  },
  error:{    
    login:{
      userNotFound: "您的登入名称或密码不正确，请再尝试。",
    },
    jwt:{
      identifierUsed: "您選用的帳戶已登記到另一個教城戶口。",
      userIdUsed: "您选用的教城户口已登记到另一个帐户。",
    }, 
  }
};
